import React from 'react';
import './ForwardRequestsListSkeleton.css';

/**
 * Skeleton loader for forward requests list
 */
const ForwardRequestsListSkeleton = () => {
  return (
    <div className="frl-skeleton-container">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="frl-skeleton-item">
          <div className="frl-skeleton-content">
            <div className="frl-skeleton-names">
              <div className="frl-skeleton-name" />
              <span className="frl-skeleton-arrow">→</span>
              <div className="frl-skeleton-name" />
            </div>
            <div className="frl-skeleton-badge" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ForwardRequestsListSkeleton;
